export default {"src":"/_next/static/media/salt.b7dfdfb0.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};